import React, { Component, PropTypes } from 'react';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import {
  Toolbar,
  ToolbarTitle,
  ToolbarGroup,
  ToolbarButton
} from 'components/Toolbar';
import * as SvgIcons from 'components/Material/SvgIcons';
import { StoreOverviewActions } from 'actions';
import { Colors, Units } from 'Css';
import * as Editors from './Modules';
import StoreSectionEditor from './StoreSectionEditor';

const css = oxygenCss({
  root: {
    position: 'absolute',
    left: Units.base,
    right: Units.base,
    top: Units.base,
    bottom: Units.base
  }
});

class StoreModuleEditor extends Component {
  static propTypes = {
    selectedModule: PropTypes.object,
    selectedSection: PropTypes.object,
    categories: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  unselect = () => {
    StoreOverviewActions.unselect();
  };

  delete = () => {
    StoreOverviewActions.deleteModule();
  };

  render() {
    const { getIntlMessage } = this.context;
    const { selectedModule, selectedSection, categories } = this.props;
    const ModuleEditor = selectedModule && Editors[selectedModule.type];
    const toolbar = (
      <Toolbar color={'#202020'}>
        <ToolbarTitle color={Colors.fullWhite}>Settings</ToolbarTitle>
        <ToolbarGroup right>
          <ToolbarButton
            tooltip={getIntlMessage('Remove')}
            onTouchTap={this.delete}
          >
            <SvgIcons.ActionDelete />
          </ToolbarButton>
          <ToolbarButton
            tooltip={getIntlMessage('Close')}
            onTouchTap={this.unselect}
          >
            <SvgIcons.ContentClear />
          </ToolbarButton>
        </ToolbarGroup>
      </Toolbar>
    );
    return (
      <ScrollableContainer backgroundColor={'#2a2a2a'} padded header={toolbar}>
        <div className={css.root}>
          {ModuleEditor && (
            <ModuleEditor
              key={selectedModule.id}
              {...selectedModule}
              categories={categories}
            />
          )}
          <StoreSectionEditor {...selectedSection} />
        </div>
      </ScrollableContainer>
    );
  }
}

export default StoreModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/StoreModuleEditor.js